// src/redux/reducers/cityReducer.js
import {
    FETCH_LANGUAGE_FAILURE,
    FETCH_LANGUAGE_REQUEST,
    FETCH_LANGUAGE_SUCCESS, 
    SET_SELECTED_LANGUAGE 
  } from '../types'; 
  
  const initialState = {
    loading: false,
    LanguageList: [],
    selectedLanguageId: null, 
    error: null,
  };
  
  const LanguageReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_LANGUAGE_REQUEST:
        return { ...state, loading: true };
      case FETCH_LANGUAGE_SUCCESS:
        return { ...state, loading: false, LanguageList: action.payload };
      case FETCH_LANGUAGE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_LANGUAGE:
        return { ...state, selectedLanguageId: action.payload };
      default:
        return state;
    }
  };
  
  export default LanguageReducer;

  